import React, { Component } from 'react';
import {Container, Row, Col,Image,Accordion,Button,OverlayTrigger,Tooltip,Form  } from 'react-bootstrap';
import loader from '../../images/loader.gif';
import Webcam from "react-webcam";

class CapturePhotoForD2D extends Component {
    constructor(props) {
        super(props)
        
        this.state = {
          videoConstraints:{facingMode: "environment"},

          
          
        }
      
    }

  
   
switchCamaraForHouseVisit = () => {
    this.setState({videoConstraints:{facingMode: "environment"}});
  }
  frontCamaraForHouseVisit = () => {
    this.setState({videoConstraints:{facingMode: "user"}});
  }
  
    render() {
        return (
             <>
             {
                this.props.stateData.photoCaptureBlock == "show" ?
                (
                    <Row>
                        <Col>
                            <div className='block_white mt-4'>
                                <h6 className='text-muted'>Upload Photo</h6>
                                <button className='btn btn-primary btn-md mt-3 w-100 btn-block' onClick={() => this.props.showCaptureClickPhoto()}><i class="fas fa-camera"></i> Capture Photo</button>
                            </div>
                        </Col>
                    </Row>   
                )
                :
                (
                    <fieldset class=""><legend>Photo Capture For D2D Visit</legend>
                        <Row>
                            <Col sm={12}>
                                <Form className="">
                                    <Form.Check
                                            inline
                                            label={"లైవ్ ఫోటో తీయటం"}
                                            name="image_capture"
                                            type="radio"
                                            id="image_capture_upload"
                                            onChange={()=>this.props.selectCaptureTypeNew("camara")}
                                            className="f-12 fw-bold"
                                            checked={this.props.stateData.camaraRadioButtonNew}
                                        />
                                        <Form.Check
                                            inline
                                            label="ఫోటో అప్లోడ్ చేయండి"
                                            name="image_capture_upload"
                                            type="radio"
                                            id="upload_photos"
                                            onChange={()=>this.props.selectCaptureTypeNew("upload")}
                                            className="f-12 fw-bold"
                                            checked={this.props.stateData.uploadImageRadioButtonNew}
                                        />
                                </Form>
                            </Col>
                            </Row>

                            {
                                this.props.stateData.selectedTypePhotoNew == "camara" ?
                                (
                                    <>
                                    
                                    <Row>
                                        <Col className="mt-2">
                                                <div className="showImgCaptureDivBSBG">{this.props.stateData.showActivityImgCaptureNew && (
                                                <> 
                                                <Webcam
                                                    audio={false}
                                                    ref={this.props.stateData.webcamRef}
                                                    screenshotFormat="image/jpeg"
                                                    videoConstraints={this.state.videoConstraints}
                                                /> 
                                                
                                                
                                                <div className="row mt-2">
                                                    <div className="col">
                                                        <h6 onClick={() => this.props.captureForActivityImageUploadNew()} className="camara_icon"><i class="fa-solid fa-camera" ></i></h6>
                                                    </div>
                                                    <div className="col">
                                                        {
                                                        this.state.videoConstraints.facingMode == "user" ?
                                                        (<h6 className="switch_camara text-center" onClick={() => this.switchCamaraForHouseVisit()} ><i class="fa-sharp fa-solid fa-repeat"></i> Switch to back camara</h6>)
                                                        :
                                                        ( <h6 className="switch_camara text-center" onClick={() => this.frontCamaraForHouseVisit()} ><i class="fa-sharp fa-solid fa-repeat"></i> Switch to front camara</h6>)
                                                        }
                                                    </div>
                                                </div>

                                                
                                                </>
                                                
                                                )}
                                                </div>
                                            </Col>
                                        </Row>

                                        <h6 className='f-12 color_red'>{this.props.stateData.validateActivityImageUpload}</h6>
                                        
                                        </>
                                )
                                :
                                (
                                    <>
                                        {
                                            this.props.stateData.manualuploadPhotoForD2D && (
                                                <Row>
                                                    <Col className="mt-2">
                                                    <div className="form-group">
                                                        <h6 className='f-12 color_red'></h6>
                                                        <label for="uploadfilesForLive" class="drop-container">
                                                            <span class="drop-title"><i class="fa-solid fa-cloud-arrow-up"></i></span>
                                                            <input type="file" id="uploadfilesForLive" className='f-14' accept="image/*" onChange={this.props.uploadMultipleFilesForPhotosNew}/>
                                                        </label>
                                                    </div>
                                                    <h6 className='f-12 color_red mt-2'>{this.props.stateData.manualUploadImageNew}</h6>
                                                    </Col>
                                                </Row>
                                            )
                                        }
                                    </>
                                    
                                )
                            }

                            {
                                this.props.stateData.photoCaptureForActivityArrNew.length>0 ?
                                (
                                <>
                                    <Row>
                                    <Col sm={12} className="">
                                        {
                                            this.props.stateData.selectedTypePhotoNew == "camara" ? 
                                            (<h6>Capture Photos : </h6>)
                                            :
                                            (<h6>Upload Images: </h6>)
                                        }
                                    
                                    </Col>
                                    <Col sm={12} className="">
                                        <div className=''>
                                            {(this.props.stateData.photoCaptureForActivityArrNew || []).map((url,index) => (
                                                <div className=''>
                                                    <img src={url.data} className='img-thumbnail w-100' style={{height:"200px"}} alt="captureImg"></img>
                                                </div>
                                            ))} 
                                        </div>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col sm={12} className='text-center'>
                                        <div className='uploadBtnScrollCls'></div>
                                        <Button variant="danger" className="red_button_event mt-2 f-14 mr-2" disabled={this.props.stateData.verifyPhotoDisabled} onClick={() => this.props.verifyPhotoForD2D()}>VERIFY
                                            {
                                                this.props.stateData.verifyLoadingSymbol == "show" ?
                                                (<Image src={loader} alt="loader" className='loader_cls ms-2 float-end'></Image>)
                                                :
                                                ("")
                                            }
                                        </Button>
                                        <Button variant="danger" className="yellow_button_event mt-2 f-14" onClick={() => this.props.retakeCapturePhoto()}>RE-TAKE </Button>
                                    </Col>
                                </Row>

                                {
                                    this.props.stateData.verificationPhotoResponse != "" ?
                                    (
                                        <Row>
                                            <Col>
                                                {
                                                    this.props.stateData.verificationPhotoResponse == "Photo Verification SuccessFully" ?
                                                    ( <h6 className='text-center color_green fw-bold mt-2'>{this.props.stateData.verificationPhotoResponse}</h6>)
                                                    :
                                                    ( <h6 className='text-center color_red fw-bold mt-2'>{this.props.stateData.verificationPhotoResponse}</h6>)
                                                }
                                            
                                            </Col>
                                        </Row>
                                    )
                                    :
                                    ("")
                                }
                                </>
                                
                                
                                )
                                :
                                ("")
                            }
                    </fieldset>
                )
             }
             
               
                </>
            
        )
    }
}
export default CapturePhotoForD2D;
  

